var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"left":"","size":_vm.size}},[_c('v-img',{attrs:{"src":_vm.img,"lazy-src":_vm.defaultImage},on:{"error":function($event){_vm.imageError = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }